import AppConstants from '../constants/AppConstants';
import PublisherActions from '../actions/PublisherActions';
import LinksActions from '../actions/LinksActions';
import RegionsActions from '../actions/RegionsActions';
import store from '../stores/redux';

const methodNames = {
    Advertiser: 'callAdvertisers',
    Period: 'callPeriods',
    Offer: 'callOffers',
    Publisher: 'callPublisher',
    CreativeType: 'callCreativeType',
    CreativeLinkId: 'callCreativeLink',
    CreativeContainerId: 'callCreativeContainer',
    CreativeBannerId: 'callCreativeBanner',
    CreativeLandingId: 'callCreativeLanding',
    CreativePromoCodeId: 'callCreativePromoCode',
    Goal: 'callGoals',
    Link: 'callLinks',
    Country: 'callRegions',
    District: 'callRegions',
    Area: 'callRegions',
    City: 'callRegions',
    Conversions: 'callConversions'
};

const events = {
    before: AppConstants.DYNAMIC_SEGMENT_SEARCH_START,
    success: AppConstants.DYNAMIC_SEGMENT_SUCCESS,
    fail: AppConstants.DYNAMIC_SEGMENT_FAIL
};

const DynamicSelectSegmentController = {
    searchDataSegment(data, callback) {
        const method = methodNames[data.segment];
        if (method && typeof this[method] === 'function') {
            this[method](data.params || {}, callback);
        } else {
            console.error(`Unknown segment type: ${data.segment}`);
            callback && callback({ items: [], total: 0, page: 1 });
        }
    },

    callAdvertisers(params, callback) {
        PublisherActions.getAdvertisers(params, () => {
            _successQuery({
                ...params,
                dataKey: 'advertisers',
            }, callback);
        }, events);
    },

    callPeriods(params, callback) {
        PublisherActions.getPeriods(params, () => {
            _successQuery({
                ...params,
                dataKey: 'periods',
            }, callback, false);
        }, events);
    },

    callOffers(params, callback) {
        PublisherActions.getOffers(params, () => {
            _successQuery({
                ...params,
                dataKey: 'offers',
            }, callback);
        }, events);
    },

    callPublisher(params, callback) {
        PublisherActions.getPublisher(params, () => {
            _successQuery({
                ...params,
                dataKey: 'publisher'
            }, callback, false);
        }, events);
    },

    callCreativeType(params, callback) {
        PublisherActions.getCreativeType(params, () => {
            _successQuery({
                ...params,
                dataKey: 'creativeType'
            }, callback, false);
        }, events);
    },

    callCreativeLink(params, callback) {
        PublisherActions.getCreativeLink(params, () => {
            _successQuery({
                ...params,
                dataKey: 'creativeLink',
            }, callback, false);
        }, events);
    },

    callCreativeContainer(params, callback) {
        PublisherActions.getCreativeContainer(params, () => {
            _successQuery({
                ...params,
                dataKey: 'creativeContainer',
            }, callback, false);
        }, events);
    },

    callCreativeBanner(params, callback) {
        PublisherActions.getCreativeBanner(params, () => {
            _successQuery({
                ...params,
                dataKey: 'creativeBanner',
            }, callback, false);
        }, events);
    },

    callCreativeLanding(params, callback) {
        PublisherActions.getCreativeLanding(params, () => {
            _successQuery({
                ...params,
                dataKey: 'creativeLanding',
            }, callback, false);
        }, events);
    },

    callCreativePromoCode(params, callback) {
        PublisherActions.getCreativePromoCode(params, () => {
            _successQuery({
                ...params,
                dataKey: 'creativePromoCode',
            }, callback, false);
        }, events);
    },

    callGoals(params, callback) {
        PublisherActions.getGoals(params, () => {
            _successQuery({
                ...params,
                dataKey: 'goals',

            }, callback);
        }, events);
    },

    callLinks(params, callback) {
        LinksActions.getListLinks(params, () => {
            _successQuery({
                ...params,
                dataKey: 'links',
            }, callback);
        }, events);
    },

    callRegions(params, callback) {
        RegionsActions.searchRegions(params, () => {
            _successQuery({
                ...params,
                dataKey: 'regions',
            }, callback);
        }, events);
    },

    callConversions(params, callback) {
        PublisherActions.getConversions(params, () => {
            _successQuery({
                ...params,
                dataKey: 'conversions',
            }, callback);
        }, events);
    }
};

const _successQuery = (params, callback, withId = true) => {
    const data = store.getState().dynamicSegment;
    let list = {};
    if (withId) {
        list = _formatData(data.list, params.dataKey);
    } else {
        list = _formatDataNoId(data.list, params.dataKey);
    }

    callback && callback({
        ...data,
        list
    });
};

const _formatData = (data, key) => {
    const getTitle = {
        common: item => item.title,
        conversions: item => item.action.title
    };

    return data.map(item => {
        let title = getTitle[key] && getTitle[key](item) || getTitle.common(item);

        return {
            ...item,
            value: item.id,
            title: (item.id === title) ? item.id : `(${item.id}) ${title}`
        };
    });
};

const _formatDataNoId = (data, key) => {
    const getTitle = {
        common: item => item.title,
        conversions: item => item.action.title
    };

    return data.map(item => {
        let title = getTitle[key] && getTitle[key](item) || getTitle.common(item);

        return {
            ...item,
            value: item.id,
            title: `${title}`
        };
    });
};

export default DynamicSelectSegmentController;